import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { apiPost } from "./api";
import { requireAuth } from "./firebase";

export async function login(email: string, password: string): Promise<void> {
  const auth = requireAuth();
  await signInWithEmailAndPassword(auth, email, password);
  await apiPost("/me/sync"); // upsert + refresh email_verified in our DB
}

export async function signup(email: string, password: string): Promise<void> {
  const auth = requireAuth();
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  await sendEmailVerification(cred.user);
  await apiPost("/me/sync"); // create our user row
}

export async function sendReset(email: string): Promise<void> {
  await sendPasswordResetEmail(requireAuth(), email);
}

export async function resendVerification(): Promise<void> {
  const user = requireAuth().currentUser;
  if (user) await sendEmailVerification(user);
}

export async function logout(): Promise<void> {
  await signOut(requireAuth());
}
